import {  generateDecryptValue} from "../constants/vtrTrip";
import { decryptTrip } from "../constants/Encrypt";

export function getNewTripKey(){
    return 'newTrip';
}

export function getOpenVtrTrips(client_id,trip_id,decrypt){
    if(client_id) {
        let rawTrips = localStorage.getItem(getOpenVtrTripKey(client_id));
        let decryptedTrip = [];
        if (rawTrips) {
            let trips = JSON.parse(rawTrips);
            if (trips && Array.isArray(trips) && trips.length > 0) {
                if (trip_id === undefined || trip_id === null) {
                    if(decrypt){
                        for (let j = 0; j < trips.length; j++) {
                          decryptedTrip[decryptedTrip.length] = decryptTrip(trips[j],client_id);
                        }
                        return decryptedTrip;
                    }
                     return trips;
                }
                for (let j = 0; j < trips.length; j++) {
                    let currentTripId = generateDecryptValue(trips[j].trip_id,client_id);
                    if ( currentTripId === trip_id) {
                        if(decrypt){
                            decryptedTrip = decryptTrip(trips[j],client_id);
                            return decryptedTrip;
                        }
                         return trips[j];
                    }
                }
            }
        }
    }
    return false;
}
export function getOpenVtrTripKey(client_id){
    if(client_id) {
        return 'vtrTrip_' + client_id;
    }
    return null;
}
